import { gql } from '@apollo/client';
export const updatePreferredLocaleMutation = gql `
  mutation updatePreferredLocale($userId: String!, $locale: String) {
    updateUser: updateUser2(id: $userId, input: { preferredLocale: $locale }) {
      id
    }
  }
`;
